import { SHIPMENT } from '../../../../constants/fulfillment-types';
import { useEntitiesFulfillmentPlanProperty } from '../../../../hooks/entities/selectors/fulfillment-plans';
import { useSellerFulfillmentProviderByExternalShipFromId } from '../../../../hooks/use-seller-fulfillment-provider';
import { useSellerLabelProvider } from '../../../../hooks/use-seller-label-provider';

export const useProviderDetails = (fulfillmentPlanId, serviceIdAndSellerLabelProviderId, externalShipFromId, fulfillmentType) => {
  const selectedProviderId = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'sellerLabelProviderId');
  const { labelProviderId: labelProviderFromEntities } = useSellerLabelProvider(selectedProviderId) || {};
  const { sellerLabelProviderId } = serviceIdAndSellerLabelProviderId || {};
  const { labelProviderId: labelProviderIdFromCSW } = useSellerLabelProvider(sellerLabelProviderId) || {};
  const labelProviderId = fulfillmentType === SHIPMENT ? labelProviderIdFromCSW || labelProviderFromEntities : undefined;
  const { fulfillmentProviderId } = useSellerFulfillmentProviderByExternalShipFromId(externalShipFromId) || {};

  return {
    labelProviderId,
    fulfillmentProviderId,
  };
};
